import { connect } from "react-redux";
import { DanhSachKiemKho } from "components/DanhSachKiemKho";
import { getListDanhSachKiemKho } from "actions/DanhSachKiemKho";

const mapStateToProps = (state) => ({
  danhsachkiemkho: state.danhsachkiemkho,
  user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
  getListDanhSachKiemKho: (dataSearch) =>
    dispatch(getListDanhSachKiemKho(dataSearch)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DanhSachKiemKho);
